// Instance
import MainAPI from "@/app/apis/main/main-api.js"

// Endpoints
import { API, ENDPOINTS } from "@/app/apis/main/_connection/connection-api.js"

// Query String
const queryString = require("querystring")

class ordersAPI extends MainAPI {
	/**
	 * @return {object} list of Orders
	 * @params queryParams
	 * */
	async getOrders(queryParams) {
		return API.get(`${ENDPOINTS.GET_ORDER}/list?${queryString.stringify(queryParams)}`)
	}

	/**
	 * @return {object} order
	 * @params orderId
	 * */
	async getOrderById(orderId) {
		return API.get(`${ENDPOINTS.GET_ORDER}/${orderId}`)
	}

	/**
	 * @return No content
	 * @params orderId
	 * @params body - tracking number, tracking link
	 * */
	async putOrderTrackingNumber(orderId, body) {
		return API.put(`${ENDPOINTS.PUT_ORDER_TRACKING_NUMBER}/${orderId}`, body)
	}

	/**
	 * @return orderId
	 * @params orderId
	 * */
	async putApproveCancelOrder(orderId, details) {
		return API.put(`${ENDPOINTS.PUT_CANCEL_ORDER}/${orderId}/cancel-approved`, details)
	}

	/**
	 * @return orderId
	 * @params orderId
	 * @params response - disapproval Reason
	 * */
	async putDisapproveCancelOrder(orderId, response) {
		///order/{orderId}/disapprove-refund
		return API.put(`${ENDPOINTS.PUT_CANCEL_ORDER}/${orderId}/disapprove-refund`, response)
	}

	/**
	 * @return orderId
	 * @params orderId
	 * @params response - disapproval Reason
	 * */
	async putDisapproveCancelProductOrder(orderId, response) {
		///order/{orderId}/disapprove-refund
		return API.put(`${ENDPOINTS.PUT_CANCEL_ORDER}/${orderId}/cancel-disapproved`, response)
	}

	/**
	 * @return No Content
	 * @param {Number} orderId
	 * @param {Object} body { status }
	 * */
	async putUpdateOrderStatus(orderId, body) {
		return API.put(`${ENDPOINTS.PUT_UPDATE_ORDER_STATUS}/${orderId}/update-order-status`, body)
	}

	/**
	 * @return {object} list of Dog Purchase Orders
	 * @params queryParams
	 * */
	async getDogPurchaseOrders(queryParams) {
		return API.get(`${ENDPOINTS.GET_ORDER}/history/admin?${queryString.stringify(queryParams)}`)
	}

	/**
	 * @params orderId
	 * */
	async putApproveRefund(orderId, details) {
		return API.put(`${ENDPOINTS.PUT_REFUND_PRODUCT_LATITUDE_INTEREST_FREE}/${orderId}/approve-refund`, details)
	}

	/**
	 * @params orderId
	 * @params response - disapproval Reason
	 * */
	async putDisapproveRefund(orderId, response) {
		return API.put(`${ENDPOINTS.PUT_CANCEL_ORDER}/${orderId}/disapprove-refund`, response)
	}

	/**
	 * @return {object} list of Dog Purchase Orders
	 * @params queryParams
	 * */
	async getPendingDogPurchaseOrders(queryParams) {
		return API.get(`${ENDPOINTS.GET_ORDER}/history/pending/admin?${queryString.stringify(queryParams)}`)
	}

	/**
	 * @return {object} list of Dog Purchase Orders
	 * @params queryParams
	 * */
	async deletePendingDogPurchaseOrders(orderId) {
		return API.put(`${ENDPOINTS.PUT_CANCEL_ORDER}/${orderId}/delete-pending`)
	}

	/**
	 * @return orderId
	 * @params orderId
	 * */
	async putApproveCancelOrderStoreCredit(orderId, details) {
		return API.put(`${ENDPOINTS.PUT_CANCEL_ORDER}/${orderId}/cancel-approved-store-credit`, details)
	}
	/**
	 * no params
	 * */
	async getOrderForDeliveryCount() {
		return API.get(`${ENDPOINTS.GET_ORDER}${ENDPOINTS.GET_FOR_DELIVERY}/count`)
	}

	/**
	 * @return {object} list of Orders Report
	 * @params queryParams
	 * */
	async getOrdersReport(queryParams) {
		return API.get(`${ENDPOINTS.GET_ORDER}/report/generation?${queryString.stringify(queryParams)}`)
	}

	/**
	 * @params orderId
	 * @return
	 * */
	async putUpdateOrderProductStatus(orderId, status) {
		return API.put(`${ENDPOINTS.PUT_PROCESS_LATITUDE_INTEREST_FREE}/product-purchase-payment/${orderId}/${status}`);
	}
}

export default new ordersAPI()
